export const userRoutes = {
  root: '/user',
};
